export const environment = {
  name: 'DEV',
  production: false,
  apiBaseUrl: '',
  b2c: {
    authority: 'https://returodev.b2clogin.com/login-dev.returosgr.ro/b2c_1a_signin_only',
    knownAuthorities: ['returodev.b2clogin.com'],
    clientId: 'd52da6e6-eb55-47d7-9cb8-6a10f3973f4f',
    scopes: [
      'https://login-dev.returosgr.ro/33f661ed-1d2a-498b-a251-9ef766d99119/Collection.Write.All',
    ],
  },
};
